export default __webpack_public_path__ + "static/media/trashcan.bf6f214e.svg";